var _circle, _path, _path2, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLfCall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.857 19.078a1.5 1.5 0 0 1-1.885-.974L6 11.91 8.86 11l1.972 6.193a1.5 1.5 0 0 1-.975 1.885Z",
  fill: "#405B73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 11.5A2.5 2.5 0 0 1 6.5 9H12v5H6.5A2.5 2.5 0 0 1 4 11.5Z",
  fill: "#405B73"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 11.5,
  r: 1.5,
  fill: "#F4CC54"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.52 7.693a.5.5 0 0 1-.088.702l-1.125.875a.5.5 0 0 1-.614-.79l1.125-.875a.5.5 0 0 1 .702.088ZM20.52 15.182a.5.5 0 0 0-.088-.702l-1.125-.875a.5.5 0 0 0-.614.79l1.125.875a.5.5 0 0 0 .702-.088ZM19.5 11.5a.5.5 0 0 1 .5-.5h1.375a.5.5 0 0 1 0 1H20a.5.5 0 0 1-.5-.5Z",
  fill: "#F4CC54"
})));
export default SvgLfCall;